import { composeIO } from 'react-compose-io'
import { fieldsConsiderarIO } from './FieldsConsiderar.IO'
import { FieldsConsiderarView } from './FieldsConsiderar.View'

export const FieldsConsiderar = composeIO(FieldsConsiderarView, fieldsConsiderarIO)
